import { render, staticRenderFns } from "./saveitem.vue?vue&type=template&id=da738a82&scoped=true"
import script from "./saveitem.vue?vue&type=script&lang=js"
export * from "./saveitem.vue?vue&type=script&lang=js"
import style0 from "./saveitem.vue?vue&type=style&index=0&id=da738a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da738a82",
  null
  
)

export default component.exports